import { Form, Input, Tabs } from "antd";
import PropTypes from "prop-types";

const { TextArea } = Input;
const { TabPane } = Tabs;

const LocalizedInput = ({ name, label, rules, textarea = false }) => {
  const getNamePath = (lang) =>
    Array.isArray(name) ? [...name, lang] : [name, lang];

  return (
    <Form.Item label={label} required>
      <Tabs defaultActiveKey="fr">
        <TabPane tab="FR" key="fr" forceRender>
          <Form.Item
            name={getNamePath("fr")}
            rules={rules}
            style={{ marginBottom: 0 }}
          >
            {textarea ? <TextArea rows={3} /> : <Input />}
          </Form.Item>
        </TabPane>

        <TabPane tab="EN" key="en" forceRender>
          <Form.Item
            name={getNamePath("en")}
            rules={[]}
            style={{ marginBottom: 0 }}
          >
            {textarea ? <TextArea rows={3} /> : <Input />}
          </Form.Item>
        </TabPane>

        <TabPane tab="AR" key="ar" forceRender>
          <Form.Item
            name={getNamePath("ar")}
            rules={[]}
            style={{ marginBottom: 0 }}
          >
            {textarea ? <TextArea rows={3} /> : <Input />}
          </Form.Item>
        </TabPane>
      </Tabs>
    </Form.Item>
  );
};

LocalizedInput.propTypes = {
  name: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]).isRequired,
  label: PropTypes.string.isRequired,
  rules: PropTypes.array,
  textarea: PropTypes.bool,
};

export default LocalizedInput;
